import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Space,
  Select,
  message,
  Row,
  Col,
  Card,
  Pagination
} from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, LinkOutlined, ExclamationCircleOutlined, SwapOutlined } from '@ant-design/icons';
import { SidebarLayout } from '../components/SidebarLayout';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Icons } from '../components/Icons';
import QRDeviceScanner from '../components/QRDeviceScanner';

const { Option } = Select;

const api = `${process.env.REACT_APP_API_URL}/truck_horses`;

const TruckHorseForm = ({
  visible,
  onCancel,
  onSubmit,
  initialValues,
  customers,
  devices,
  traylers,
  types,
  selectedClient
}) => {
  const [form] = Form.useForm();
  const { user } = useAuth();

  useEffect(() => {
    if (visible) {
      const values = { ...initialValues };
      values.idcustomer = selectedClient.client.id;
      form.setFieldsValue(values || {});
    } else {
      form.resetFields();
    }
  }, [visible, initialValues, selectedClient]);

  return (
    <Modal
      visible={visible}
      title={initialValues ? 'Editar Cavalo' : 'Novo Cavalo'}
      onCancel={onCancel}
      onOk={() => {
        form.validateFields()
          .then(values => {
            form.resetFields();
            onSubmit(values);
          });
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="dsplate"
          label="Placa"
          rules={[
            { required: true, message: 'Placa é obrigatória' },
            { max: 8, message: 'Máximo de 8 caracteres' },
            { pattern: /^[A-Z0-9-]+$/, message: 'Apenas letras maiúsculas, números e hífen' }
          ]}
        >
          <Input
            maxLength={8}
            onChange={e => {
              const upper = e.target.value.toUpperCase();
              form.setFieldsValue({ dsplate: upper });
            }}
          />
        </Form.Item>
        <Form.Item
          name="cdtype"
          label="Tipo"
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            allowClear
          >
            {types.map(type => (
              <Option key={type.id} value={type.id}>{type.dsname}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="dsdrivername"
          label="Motorista"
          rules={[
            { max: 100, message: 'Máximo de 100 caracteres' }
          ]}
        >
          <Input maxLength={100} />
        </Form.Item>
        <Form.Item
          name="iddevice"
          label="Dispositivo"
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            allowClear
          >
            {devices.filter(device => device.cdtype === 1).map(device => (
              <Option key={device.id} value={device.id}>{device.dsdeveui}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="idtrayler"
          label="Carreta"
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            allowClear
          >
            {traylers.map(trayler => (
              <Option key={trayler.id} value={trayler.id}>{trayler.dsplate}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="dswifissid"
          label="WiFi SSID"
          rules={[
            { max: 100, message: 'Máximo de 100 caracteres' }
          ]}
        >
          <Input maxLength={100} />
        </Form.Item>
        <Form.Item
          name="dswifipwd"
          label="WiFi Password"
          rules={[
            { max: 100, message: 'Máximo de 100 caracteres' }
          ]}
        >
          <Input.Password maxLength={100} />
        </Form.Item>
        <Form.Item
          name="dsapssid"
          label="AP SSID"
          rules={[
            { max: 100, message: 'Máximo de 100 caracteres' }
          ]}
        >
          <Input maxLength={100} />
        </Form.Item>
        <Form.Item
          name="dsappwd"
          label="AP Password"
          rules={[
            { max: 100, message: 'Máximo de 100 caracteres' }
          ]}
        >
          <Input.Password maxLength={100} />
        </Form.Item>
        <Form.Item
          name="nrtempalert"
          label="Temperatura Alerta"
          rules={[
            { type: 'number', message: 'Deve ser um número' }
          ]}
        >
          <InputNumber type='number' style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="nrtempalarm"
          label="Temperatura Alarme"
          rules={[
            { type: 'number', message: 'Deve ser um número' }
          ]}
        >
          <InputNumber type='number' style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="nrloginterval"
          label="Intervalo de Log"
          rules={[
            { type: 'number', message: 'Deve ser um número' }
          ]}
        >
          <InputNumber type='number' style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const TruckHorseDevicesModal = ({
  visible,
  onCancel,
  horseId,
  devices,
  horseDevices,
  deviceStatuses,
  onSave
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        position1: horseDevices.find(d => d.nrposition === 1)?.iddevice,
        position2: horseDevices.find(d => d.nrposition === 2)?.iddevice,
        position3: horseDevices.find(d => d.nrposition === 3)?.iddevice,
        position4: horseDevices.find(d => d.nrposition === 4)?.iddevice,
        position5: horseDevices.find(d => d.nrposition === 5)?.iddevice,
        position6: horseDevices.find(d => d.nrposition === 6)?.iddevice,        status1: devices.find(d => d.id === horseDevices.find(hd => hd.nrposition === 1)?.iddevice)?.cddisplaystatus,
        status2: devices.find(d => d.id === horseDevices.find(hd => hd.nrposition === 2)?.iddevice)?.cddisplaystatus,
        status3: devices.find(d => d.id === horseDevices.find(hd => hd.nrposition === 3)?.iddevice)?.cddisplaystatus,
        status4: devices.find(d => d.id === horseDevices.find(hd => hd.nrposition === 4)?.iddevice)?.cddisplaystatus,
        status5: devices.find(d => d.id === horseDevices.find(hd => hd.nrposition === 5)?.iddevice)?.cddisplaystatus,
        status6: devices.find(d => d.id === horseDevices.find(hd => hd.nrposition === 6)?.iddevice)?.cddisplaystatus,
      });
    }
  }, [visible, horseDevices, devices]);
  const handleDeviceChange = (position, value) => {
    if (!value) return;

    const currentValues = form.getFieldsValue();
    const positions = [1, 2, 3, 4, 5, 6];
    
    positions.forEach(pos => {
      if (pos !== position && currentValues[`position${pos}`] === value) {
        form.setFieldsValue({ [`position${pos}`]: undefined });
      }
    });

    const device = devices.find(d => d.id === value);
    if (device) {
      form.setFieldsValue({ [`status${position}`]: device.cddisplaystatus });
    }
  };
  const handleSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();      const payload = {
        devices: [
          {nrposition: 1, iddevice: values.position1, cddisplaystatus: values.status1 === undefined ? null : values.status1},
          {nrposition: 2, iddevice: values.position2, cddisplaystatus: values.status2 === undefined ? null : values.status2},
          {nrposition: 3, iddevice: values.position3, cddisplaystatus: values.status3 === undefined ? null : values.status3},
          {nrposition: 4, iddevice: values.position4, cddisplaystatus: values.status4 === undefined ? null : values.status4},
          {nrposition: 5, iddevice: values.position5, cddisplaystatus: values.status5 === undefined ? null : values.status5},
          {nrposition: 6, iddevice: values.position6, cddisplaystatus: values.status6 === undefined ? null : values.status6}
        ]
      }

      await axios.post(`${process.env.REACT_APP_API_URL}/truck_horse_devices/link_all/${horseId}`, payload);
      
      message.success('Dispositivos vinculados com sucesso');
      onSave();
    } catch (error) {
      message.error('Erro ao vincular dispositivos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title="Vincular Dispositivos às Posições"
      onCancel={onCancel}
      onOk={handleSave}
      confirmLoading={loading}
      width={800}
    >      <Form form={form} layout="vertical">
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={24} md={12} lg={12}>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position1" label="Posição 1 (Motorista)">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(1, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(1, device.id);
                    form.setFieldsValue({ position1: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status1" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position3" label="Posição 3">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(3, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(3, device.id);
                    form.setFieldsValue({ position3: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status3" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position5" label="Posição 5">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(5, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(5, device.id);
                    form.setFieldsValue({ position5: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status5" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12}>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position2" label="Posição 2 (Passageiro)">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(2, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(2, device.id);
                    form.setFieldsValue({ position2: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status2" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position4" label="Posição 4">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(4, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(4, device.id);
                    form.setFieldsValue({ position4: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status4" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position6" label="Posição 6">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(6, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(6, device.id);
                    form.setFieldsValue({ position6: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status6" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export const TruckHorses = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [visible, setVisible] = useState(false);
  const [devicesModalVisible, setDevicesModalVisible] = useState(false);
  const [selectedHorse, setSelectedHorse] = useState(null);
  const [horseDevices, setHorseDevices] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [messageApi, contextHolder] = message.useMessage();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;

  const [customers, setCustomers] = useState([]);
  const [devices, setDevices] = useState([]);
  const [traylers, setTraylers] = useState([]);
  const [types, setTypes] = useState([]);
  const [typeFilter, setTypeFilter] = useState(null);
  const [deviceStatuses, setDeviceStatuses] = useState([]);

  const [horseToTransfer, setHorseToTransfer] = useState(null);
  const [selectedTransferClient, setSelectedTransferClient] = useState(null);
  const [transferLoading, setTransferLoading] = useState(false);
  const [transferModalVisible, setTransferModalVisible] = useState(false);
  const [transferHorseDevices, setTransferHorseDevices] = useState([]);
  const [transferTraylerDevices, setTransferTraylerDevices] = useState([]);

  const { user, selectedClient } = useAuth();

  useEffect(() => {
    if (selectedClient) {
      fetchData();
      fetchCustomers();
      fetchDevices();
      fetchTraylers();
      fetchTypes();
      fetchDeviceStatuses();
    }
  }, [selectedClient]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${api}?selectedClient=${selectedClient.client.id}`);
      setData(res.data);
    } catch {
      messageApi.error('Erro ao buscar cavalos');
    }
    setLoading(false);
  };

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/customers`);
      setCustomers(res.data);
    } catch {
      messageApi.error('Erro ao buscar clientes');
    }
  };

  const fetchDevices = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/devices?selectedClient=${selectedClient.client.id}`);
      setDevices(res.data);
    } catch {
      messageApi.error('Erro ao buscar dispositivos');
    }
  };

  const fetchTraylers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/truck_traylers?selectedClient=${selectedClient.client.id}`);
      setTraylers(res.data);
    } catch {
      messageApi.error('Erro ao buscar carretas');
    }
  };

  const fetchTypes = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/truck_horse_type`);
      setTypes(res.data);
    } catch {
      messageApi.error('Erro ao buscar tipos de cavalo');
    }
  };
  const fetchDeviceStatuses = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/display_status`);
      setDeviceStatuses(res.data);
    } catch {
      messageApi.error('Erro ao buscar status de dispositivos');
    }
  };

  const handleCreate = async values => {
    try {
      
      values.idcustomer = selectedClient.client.id;

      await axios.post(api, values);
      messageApi.success('Cavalo criado com sucesso');
      setVisible(false);
      fetchData();
    }  catch (error) {
      var apiMsg = 'Erro ao criar cavalo';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
  };

  const handleUpdate = async values => {
    try {
      if (!user?.nrisadmin && selectedClient) {
        values.idcustomer = selectedClient.client.id;
      }
      
      await axios.put(`${api}/${editing.id}`, values);
      messageApi.success('Cavalo atualizado com sucesso');
      setVisible(false);
      setEditing(null);
      fetchData();
    } catch (error) {
      var apiMsg = 'Erro ao atualizar cavalo';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
  };

  const handleDelete = id => {
    Modal.confirm({
      title: 'Tem certeza que deseja remover este cavalo?',
      content: 'Esta ação não poderá ser desfeita.',
      okText: 'Sim, remover',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          await axios.delete(`${api}/${id}`);
          messageApi.success('Cavalo removido com sucesso');
          fetchData();
        } catch (error) {
          var apiMsg = 'Erro ao remover cavalo';
          if (error.response?.status != 500) {
            apiMsg +=  ': ' + error.response?.data?.error || '!';
          }
          messageApi.error(apiMsg);
        }
      }
    });
  };

  const handleOpenDevicesModal = async (horse) => {
    setSelectedHorse(horse);
    setDevicesModalVisible(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/truck_horse_devices/horse/${horse.id}`);
      setHorseDevices(res.data);
    } catch (error) {
      messageApi.error('Erro ao buscar dispositivos vinculados');
    }
  };

  const handleOpenTransferModal = async (horse) => {
    setHorseToTransfer(horse);
    setSelectedTransferClient(null);
    setTransferModalVisible(true);
    setTransferHorseDevices([]);
    setTransferTraylerDevices([]);
    // Buscar dispositivos do cavalo
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/truck_horse_devices/horse/${horse.id}`);
      setTransferHorseDevices(res.data);
    } catch {}
    // Buscar dispositivos da carreta, se houver
    if (horse.idtrayler) {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/truck_trayler_devices/trayler/${horse.idtrayler}`);
        setTransferTraylerDevices(res.data);
      } catch {}
    }
  };

  const handleTransfer = async () => {
    if (!selectedTransferClient) {
      return messageApi.warning('Selecione o novo cliente');
    }
    setTransferLoading(true);
    try {
      await axios.post(`${api}/${horseToTransfer.id}/transfer`, { idcustomer: selectedTransferClient });
      messageApi.success('Transferência realizada com sucesso');
      setTransferModalVisible(false);
      setHorseToTransfer(null);
      fetchData();
    } catch (error) {
      var apiMsg = 'Erro ao transferir cavalo';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    } finally {
      setTransferLoading(false);
    }
  };

  return (
    <SidebarLayout>
      {contextHolder}
      <div style={{ padding: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
          <h1 style={{ fontSize: 30}}>
            Cavalos
          </h1>
          <div
            style={{
              minWidth: 200,
              width: '100%',
              maxWidth: 320,
              marginTop: 8,
              marginLeft: 'auto',
              ...(window.innerWidth <= 600
                ? { order: 2, marginTop: 12, marginLeft: 0 }
                : { order: 0, marginTop: 0 })
            }}
          >
            <Select
              allowClear
              placeholder="Filtrar por tipo"
              style={{ width: '100%' }}
              value={typeFilter}
              onChange={setTypeFilter}
            >
              {types.map(type => (
                <Option key={type.id} value={type.id}>{type.dsname}</Option>
              ))}
            </Select>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 25 }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditing(null);
                setVisible(true);
              }}
              >
              Novo
              </Button>
              <Input.Search
              placeholder="Buscar"
              allowClear
              onSearch={value => setSearchText(value)}
              onChange={e => setSearchText(e.target.value)}
              style={{ width: 180 }}
              />
            </div>

            <Row gutter={[42, 32]}>
              {data
              .filter(item =>
                item.dsplate?.toLowerCase().includes(searchText.toLowerCase()) &&
                (typeFilter ? item.cdtype === typeFilter : true)
              )
              .slice((currentPage - 1) * pageSize, currentPage * pageSize)
              .map(record => (
                <Col xs={24} sm={12} md={8} lg={8} key={record.id}>
                <Card
                  actions={[
                  <LinkOutlined key="link" onClick={() => handleOpenDevicesModal(record)} />,
                  <EditOutlined key="edit" onClick={() => { setEditing(record); setVisible(true); }} />,
                  <DeleteOutlined key="delete" style={{ color: 'red' }} onClick={() => handleDelete(record.id)} />, 
                  user?.isAdmin && (
                    <SwapOutlined key="transfer" style={{ color: '#1890ff' }} onClick={() => handleOpenTransferModal(record)} />
                  )
                  ].filter(Boolean)}
                  className='fade-in'
                  style={{
                  boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                  borderRadius: 16,
                  padding: 0,
                  border: '1px solid #f0f0f0',
                  minHeight: 320,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                  }}
                  bodyStyle={{
                  padding: 24,
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                  <img src={Icons.horseBlack} alt="horse" style={{ width: 36, height: 36, marginRight: 12, marginLeft: -5 }} />
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 18, color: '#222' }}>{record.dsplate}</div>
                    <div style={{ color: '#888', fontSize: 13 }}>
                    {types.find(t => t.id === record.cdtype)?.dsname || record.cdtype}
                    </div>
                  </div>
                  </div>
                  <div style={{ flex: 1 }}>

                   <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', rowGap: 8 }}>
                      <div style={{ display: 'contents' }}>
                        <span style={{ fontWeight: 500 }}>
                          <i className='fa fa-id-card' style={{marginRight: 4}}></i> Placa:
                        </span>
                        <span style={{ color: '#333' }}>{record.dsplate}</span>
                      </div>
                      <div style={{ display: 'contents' }}>
                        <span style={{ fontWeight: 500 }}>
                          <i className='fa fa-tag' style={{marginRight: 7}}></i> Tipo:
                        </span>
                        <span style={{ color: '#333' }}>{types.find(t => t.id === record.cdtype)?.dsname || record.cdtype}</span>
                      </div>
                      <div style={{ display: 'contents' }}>
                        
                        <span style={{ fontWeight: 500 }}>
                          <i className='fa fa-user' style={{marginRight: 7}}></i> Motorista:
                        </span>
                        <span style={{ color: '#333' }}>{record.dsdrivername || <span style={{ color: '#bbb' }}>-</span>}</span>
                      </div>
                      <div style={{ display: 'contents' }}>
                        <span style={{ fontWeight: 500 }}>
                          <img src={Icons.deviceBlack} alt="device" style={{ width: 16, marginLeft: -3, marginRight: 3 }} /> Dispositivo:
                        </span>
                        <span style={{ color: '#333' }}>
                          {devices.find(d => d.id === record.iddevice)?.dsdeveui || <span style={{ color: '#bbb' }}>-</span>}
                        </span>
                      </div>
                      <div style={{ display: 'contents' }}>
                        <span style={{ fontWeight: 500 }}>
                          <img src={Icons.traylerBlack} alt="device" style={{ width: 18, marginLeft: -3, marginBottom: -3, marginRight: 6}} />Carreta:
                        </span>
                        <span style={{ color: '#333' }}>
                          {traylers.find(t => t.id === record.idtrayler)?.dsplate || <span style={{ color: '#bbb' }}>-</span>}
                        </span>
                      </div>
                      <div style={{ display: 'contents' }}>
                        

                        <span style={{ fontWeight: 500 }}>
                          <i className='fa fa-exclamation-circle' style={{ marginRight: 8, color: '#faad14' }}></i>Temp. Alerta:
                        </span>
                        <span style={{ color: '#333' }}>{record.nrtempalert ?? <span style={{ color: '#bbb' }}>-</span>} °C</span>
                      </div>
                      <div style={{ display: 'contents' }}>
                        <span style={{ fontWeight: 500 }}>
                          <i className='fa fa-exclamation-triangle' style={{ marginRight: 7, color: '#f5222d' }}></i>Temp. Alarme:
                        </span>
                        <span style={{ color: '#333' }}>{record.nrtempalarm ?? <span style={{ color: '#bbb' }}>-</span>} °C</span>
                      </div>
                    </div>


                  </div>
                </Card>
                </Col>
              ))}
            </Row>

            <div style={{ marginTop: 24, display: 'flex', justifyContent: 'end' }}>
              <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={data.filter(item =>
                item.dsplate?.toLowerCase().includes(searchText.toLowerCase()) ||
                item.dsdrivername?.toLowerCase().includes(searchText.toLowerCase())
              ).length}
              onChange={page => setCurrentPage(page)}
              showSizeChanger={false}
              />
            </div>

            <TruckHorseForm
              visible={visible}
              onCancel={() => {
            setVisible(false);
            setEditing(null);
          }}
          onSubmit={editing ? handleUpdate : handleCreate}
          initialValues={editing}
          customers={customers}
          devices={devices}
          traylers={traylers}
          types={types}
          selectedClient={selectedClient}
        />        <TruckHorseDevicesModal
          visible={devicesModalVisible}
          onCancel={() => setDevicesModalVisible(false)}
          horseId={selectedHorse?.id}
          devices={devices}
          horseDevices={horseDevices}
          deviceStatuses={deviceStatuses}          onSave={() => {
            setDevicesModalVisible(false);
            fetchData();
            fetchDevices();
          }}
        />        <Modal
          open={transferModalVisible}
          title={<div style={{display:'flex',alignItems:'center',gap:10}}><SwapOutlined style={{color:'#1890ff',fontSize:22}}/>Transferir Conjunto</div>}
          onCancel={() => setTransferModalVisible(false)}
          onOk={handleTransfer}
          confirmLoading={transferLoading}
          okText="Transferir"
          cancelText="Cancelar"
          bodyStyle={{padding:'32px 24px 16px 24px', borderRadius:16}}
        >
          <div>
            <div style={{display:'flex',alignItems:'center',gap:16,marginBottom:18}}>
              <img src={Icons.horseBlack} alt="horse" style={{ width: 32, height: 32, marginRight: 2 }} />
              <div>
                <div style={{fontWeight:700,fontSize:18,color:'#222'}}>{horseToTransfer?.dsplate}</div>
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'140px 1fr',rowGap:8,marginBottom:10}}>
              <div style={{fontWeight:500,color:'#555'}}>Control Panel:</div>
              <div style={{color:'#333'}}>{horseToTransfer && devices.find(d => d.id === horseToTransfer.iddevice)?.dsdeveui || <span style={{ color: '#bbb' }}>-</span>}</div>
            </div>
            <div style={{marginTop:18}}>
              <div style={{fontWeight:600,marginBottom:6,color:'#222'}}>Dispositivos vinculados ao cavalo:</div>
              <div style={{display:'flex',flexWrap:'wrap',gap:10}}>
                {transferHorseDevices.length === 0 && <span style={{ color: '#bbb' }}>Nenhum</span>}
                {[...transferHorseDevices]
                  .sort((a, b) => a.nrposition - b.nrposition)
                  .map(hd => {
                    const dev = devices.find(d => d.id === hd.iddevice);
                    return (
                      <div key={hd.iddevice} style={{background:'#f4f6fa',borderRadius:8,padding:'6px 14px',fontSize:14,display:'flex',alignItems:'center',gap:8,border:'1px solid #e6e8ee'}}>
                        <span style={{fontWeight:500,color:'#555'}}>Posição {hd.nrposition}:</span>
                        <span style={{color:'#222'}}>{dev ? dev.dsdeveui : hd.iddevice}</span>
                      </div>
                    );
                  })}
              </div>
            </div>
            {/* {horseToTransfer && traylers.find(t => t.id === horseToTransfer.idtrayler)?.dsplate || <span style={{ color: '#bbb' }}>-</span>} */}
            {horseToTransfer && horseToTransfer.idtrayler && (
              <>
                <div style={{display:'flex',alignItems:'center',gap:16,marginBottom:18, marginTop:24}}>
                  <img src={Icons.traylerBlack} alt="trayler" style={{ width: 32, height: 32, marginRight: 2 }} />
                  <div>
                    <div style={{fontWeight:700,fontSize:18,color:'#222'}}>{traylers.find(t => t.id === horseToTransfer.idtrayler)?.dsplate}</div>
                  </div>
                </div>
                <div style={{marginTop:18}}>
                  <div style={{fontWeight:600,marginBottom:6,color:'#222'}}>Dispositivos vinculados à carreta:</div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:10}}>
                    {transferTraylerDevices.length === 0 && <span style={{ color: '#bbb' }}>Nenhum</span>}
                    {[...transferTraylerDevices]
                      .sort((a, b) => a.nrposition - b.nrposition)
                      .map(td => {
                        const dev = devices.find(d => d.id === td.iddevice);
                        return (
                          <div key={td.iddevice} style={{background:'#f4f6fa',borderRadius:8,padding:'6px 14px',fontSize:14,display:'flex',alignItems:'center',gap:8,border:'1px solid #e6e8ee'}}>
                            <span style={{fontWeight:500,color:'#555'}}>Posição {td.nrposition}:</span>
                            <span style={{color:'#222'}}>{dev ? dev.dsdeveui : td.iddevice}</span>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </>
            )}
          </div>
          <div style={{marginTop:10}}>
            <div style={{fontWeight:500,marginBottom:6}}>Selecione o novo cliente:</div>
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder="Selecione o novo cliente"
              value={selectedTransferClient}
              onChange={setSelectedTransferClient}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {customers
                .filter(c => c.id !== horseToTransfer?.idcustomer)
                .map(client => (
                  <Option key={client.id} value={client.id}>{client.dsname}</Option>
                ))}
            </Select>
          </div>
        </Modal>
      </div>
    </SidebarLayout>
  );
};
